// Convert to a currency string
export function toCurrency(n, x) {
    if (typeof x === 'undefined') {
        x = 2;
    }
    var re = '\\d(?=(\\d{3})+' + (x > 0 ? '\\.' : '$') + ')';
    return '$' + n.toFixed(Math.max(0, ~~x)).replace(new RegExp(re, 'g'), '$&,');
}

// Convert number to percentage with optional max
export function toPercentage(input, max) {
    var maxRating = isNaN(max) ? 1.0 : max;
    return (Math.round(input * 100.0 / maxRating) + '%');
}

// Convert a number to words, supports a max of 6 digits (i.e. 999999)
const num = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const tens = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

export function inWords(n) {
    if (isNaN(n)) return '';
    if (n < -1 || n > 999999) return 'overflow';
    if (n < 20) return num[n];

    var digit = n % 10;
    if (n < 100) return tens[Math.floor(n / 10) - 2] + (digit ? '-' + num[digit] : '');
    if (n < 1000) return num[Math.floor(n / 100)] + ' hundred' + (n % 100 == 0 ? '' : ' ' + inWords(n % 100));
    return inWords(Math.floor(n / 1000)) + ' thousand' + (n % 1000 == 0 ? '' : ' ' + inWords(n % 1000));
}

// Convert numbers into phone format
export function tel(tel) {
    if (!tel) { return '' }

    var value = tel.toString().trim().replace(/^\+/, '');
    if (value.match(/[^0-9]/)) {
        return tel;
    }

    if (value.length < 4) {
        return '(' + value;
    } else if (value.length < 7) {
        return '(' + value.slice(0, 3) + ') ' + value.slice(3);
    }

    return '(' + value.slice(0, 3) + ') ' + value.slice(3, 6) + '-' + value.slice(6, 10);
}